module.exports = __webpack_public_path__ + "img/tmp-patients-status-6.8813e10a.svg";